import { lazy } from "react";

const Root = lazy(() => import("../../components/Roles/Client/SecureMessages"));

const Inbox = lazy(
  () => import("../../components/Roles/Client/SecureMessages/Inbox")
);

const SentMessages = lazy(
  () => import("../../components/Roles/Client/SecureMessages/SentMessages")
);

const SpecialOffers = lazy(
  () => import("../../components/Roles/Client/SecureMessages/SpecialOffers")
);

const CreateMessage = lazy(
  () => import("../../components/Roles/Client/SecureMessages/CreateMessage")
);

const ThreadMessages = lazy(
  () => import("../../components/Roles/Client/SecureMessages/ThreadMessages")
);

export const ClientSecureMessages = [
  {
    path: "/app/secure-messages",
    component: Root,

    routes: [
      {
        path: "/app/secure-messages/message/:messageId",
        component: ThreadMessages,
      },

      {
        path: "/app/secure-messages/create-message",
        component: CreateMessage,
      },
      {
        path: "/app/secure-messages/offers",
        component: SpecialOffers,
      },
      {
        path: "/app/secure-messages/sent-messages",
        component: SentMessages,
      },
      {
        path: "/app/secure-messages/inbox",
        component: Inbox,
      },
    ],
  },
];
